import React from 'react';
import { Award, Heart, Users } from 'lucide-react';
import { aboutText } from '../data/mockData';

export const About = () => {
  const features = [
    {
      icon: Award,
      title: "Qualität",
      description: "Erstklassige Friseurkunst mit Premium-Produkten"
    },
    {
      icon: Heart,
      title: "Leidenschaft",
      description: "Mit Herz und Hingabe für deine Schönheit"
    },
    {
      icon: Users,
      title: "Erfahrung",
      description: "Professionelles Team mit langjähriger Expertise"
    }
  ];

  return (
    <section id="about" className="section-padding bg-coconut">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="about-image-container aspect-[3/4]">
                <img 
                  src="https://customer-assets.emergentagent.com/job_d2fafa34-76d1-4e50-83f7-dffe77c91e9f/artifacts/ys7505d3_IMG_1579%202.jpg"
                  alt="Salon Interior"
                  className="about-image"
                />
              </div>
              <div className="about-image-container aspect-square">
                <img 
                  src="https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/ohe00vfo_b53064b4-65ff-4de5-a96a-12fe5ac7ca4a.JPG"
                  alt="Hair Styling"
                  className="about-image"
                />
              </div>
            </div>
            <div className="space-y-4 mt-8">
              <div className="about-image-container aspect-square">
                <img 
                  src="https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/me26hvx8_C68839A8-3E1D-403C-B41E-542738A503D4.jpg"
                  alt="Salon Wash Basin Area"
                  className="about-image"
                />
              </div>
              <div className="about-image-container aspect-[2/3]">
                <img 
                  src="https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/6rwpmeju_IMG_1702.jpg"
                  alt="Beautiful Blonde Hair Styling"
                  className="about-image"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="section-title mb-6">
                {aboutText.heading}
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                {aboutText.description}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                {aboutText.team}
              </p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 gap-6 mt-8">
              {features.map((feature, index) => (
                <div key={index} className="feature-card group">
                  <div className="flex items-start space-x-4">
                    <div className="feature-icon-container">
                      <feature.icon className="w-6 h-6 text-accent" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2 group-hover:text-accent transition-colors">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
